import _ from 'lodash';
import React, { useEffect } from 'react';

import { Systems } from 'scbk-services/config/enums';
import { useConfigStore } from 'scbk-services/config/stores/configStore';
import { getUrlParameter } from 'scbk-services/utils/urlParameter';

export const useSystemContext = () => {
    const setStoreSystem = useConfigStore((state) => state.setSystem);
    const getSystem = useConfigStore((state) => state.getSystem);

    /**
     * 최초 System 결정
     *
     * 우선순위
     * 1. URL parameter의 system
     * 2. .env의 VITE_SYSTEM
     */
    const getPreDefinedSystem = (metaEnv: ImportMetaEnv) => {
        // First, get pre-defined system from url params
        const systemParam = getUrlParameter('system');

        if (systemParam && Object.values(Systems).includes(systemParam as Systems)) {
            return systemParam as Systems;
        }

        // Finally, fall back to metaEnv
        return metaEnv.VITE_SYSTEM as Systems;
    };

    /**
     * System 변경
     */
    const setSystem = (system: Systems) => {
        const currentSystem = getSystem();

        let finalSystem = currentSystem;

        if (!_.isEmpty(system) && Object.values(Systems).includes(system as Systems)) {
            finalSystem = system;
        }

        if (currentSystem !== finalSystem) {
            setStoreSystem(finalSystem);
        }
    };

    /**
     * System 변경 감지
     */
    const useSubscribeSystemContext = (
        callback: (changes: { system?: Systems }) => void,
        dependencies: React.DependencyList = [],
    ) => {
        useEffect(() => {
            const unsubscribe = useConfigStore.subscribe((state, prevState) => {
                const changes: {
                    system?: Systems;
                } = {};

                if (state.currentSystem !== prevState.currentSystem) {
                    changes.system = state.currentSystem;
                }

                if (Object.keys(changes).length > 0) {
                    callback(changes);
                }
            });

            return () => unsubscribe();

            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [...dependencies]);
    };

    return {
        getSystem,
        setSystem,
        getPreDefinedSystem,
        useSubscribeSystemContext,
    };
};

export default useSystemContext;
